/** @type {import('tailwindcss').Config} */
module.exports = {
  prefix: "tw-",
  content: ["./public/index.html", "./src/**/*.{vue,js,ts,jsx,tsx}"],
  theme: {
    extend: {
      padding: {
        'sidebar-width': "315px",
      },
      fontSize: {
        'tiny': '0.75rem',    // 12px
        'small': '0.875rem',   // 14px
        'base': '1rem',        // 16px
        'large': '1.25rem',    // 20px
        'xl': '1.5rem',        // 24px
        '2xl': '2rem',         // 32px
        '3xl': '2.5rem',       // 40px
        'huge': '3rem',        // 48px
      },
      colors: {
        primary: {
          25: "#F3F8FE",
          50: "#E6F1FD",
          100: "#B0D4FA",
          200: "#8ABFF8",
          300: "#54A1F4",
          400: "#338FF2",
          500: "#0073EF",
          600: "#0069D9",
          700: "#0052AA",
          800: "#003F83",
          900: "#003064",
        },
        secondry: {
          50: "#FFF9EE",
          100: "#FFECCC",
          200: "#FFE3B3",
          300: "#FFD690",
          400: "#FFCE7A",
          500: "#FFC259",
          600: "#E8B151",
          700: "#B58A3F",
          800: "#B58A3F",
          900: "#6B5125",
        },
        "blue-dark": {
          50: "#E8EBEF",
          100: "#B7C0CE",
          200: "#95A2B7",
          300: "#647796",
          350: "#303C54",
          400: "#465D81",
          500: "#183462",
          600: "#162F59",
          700: "#112546",
          800: "#0D1D36",
          900: "#0A1629",
        },
        gray: {
          50: "#FBFCFC",
          100: "#F4F5F6",
          200: "#EEF0F2",
          300: "#E6E9EC",
          400: "#E1E5E9",
          500: "#DADEE3",
          600: "#C6CACF",
          700: "#9B9EA1",
          800: "#787A7D",
          900: "#5C5D5F",
        },
        green: {
          50: "#E9F9EF",
          100: "#BAEDCD",
          200: "#99E4B5",
          300: "#6BD893",
          400: "#4ED17E",
          500: "#22C55E",
          600: "#1FB356",
          700: "#188C43",
          800: "#136C34",
          900: "#0E5327",
        },
        red: {
          50: "#FFECEB",
          100: "#FFC3BF",
          200: "#FFA6A1",
          300: "#FF7D76",
          400: "#FF645B",
          500: "#FF3D32",
          600: "#E8382E",
          700: "#B52B24",
          800: "#8C221C",
          900: "#6B1A15",
        },
        static: {
          purple: "#005BE2",
          green: "#56BB80",
          red: "#C80F0F",
          error: "#FF4115",
          orange: "#FF8600",
          yellow: "#FFC300",
          inputBorder: "#D6D6D6",
          inputBorder2: "#E2E2E2",
          headerGray: "#B3BCC1",
        },
      },
    },
    screens: {
      xs: "0px",
      sm: "600px",
      // => @media (min-width: 600px) { ... }

      md: "960px",
      // => @media (min-width: 960px) { ... }

      lg: "1264px",
      // => @media (min-width: 1264px) { ... }

      xl: "1536px",
      // => @media (min-width: 1536px) { ... }

      "2xl": "1904px",
      // => @media (min-width: 1904px) { ... }
    },
  },
  plugins: [],
}

